import importExcel from './importExcel';
import view from './view';
import total from './total';
import comment from './comment';
export default {
    importExcel,
    view,
    comment,
    total
}